// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".92ec7a187b900cb12f508f3cb308ab19688dbd21.chunk.js";
};